var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInStockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3817 0.513274C10.5671 0.397385 10.7813 0.335937 11 0.335938C11.2187 0.335938 11.4329 0.397385 11.6183 0.513274L19.673 5.54744L11 10.6493L2.327 5.54744L10.3817 0.513274ZM0.509337 7.18544C0.502987 7.23535 0.49987 7.28562 0.500004 7.33594V16.6693C0.500004 16.8671 0.550331 17.0618 0.646254 17.2348C0.742176 17.4079 0.880541 17.5537 1.04834 17.6586L9.83334 23.1489V12.6699L0.509337 7.18544ZM12.1667 23.1489L20.9517 17.6586C21.1195 17.5537 21.2578 17.4079 21.3538 17.2348C21.4497 17.0618 21.5 16.8671 21.5 16.6693V7.33594C21.5 7.28577 21.4965 7.23444 21.4907 7.18544L12.1667 12.6688V23.1489Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStockIcon);
export default __webpack_public_path__ + "static/media/in-stock-icon.8d02d03e7d8db8436c3cb2784d21c560.svg";
export { ForwardRef as ReactComponent };